import { Link } from "react-router-dom";
import { Settings2 } from "lucide-react";
import { fmtTL } from "../../lib/format";

// Bordro hesap parametreleri şeridi: asgari ücret, SGK tavanı, oranlar, GV dilimleri (Sabit Tanımlar'a bağlantı)
export default function PayrollParams({ params, sgk, testid = "payroll-params" }) {
  if (!params) return null;
  const n = sgk?.normal || {};
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-slate-600 bg-slate-50 border border-slate-200 rounded-md px-3 py-2" data-testid={testid}>
      <span><b>Asgari ücret</b> {fmtTL(params.min_wage_gross)}</span>
      <span><b>SGK tavanı</b> ×{params.sgk_ceiling_multiplier} = {fmtTL(params.min_wage_gross * params.sgk_ceiling_multiplier)}</span>
      <span><b>SGK</b> işçi %{n.employee} + işsizlik %{n.unemp_employee} · işveren %{n.employer} + %{n.unemp_employer}{sgk?.discount_5510 ? ` (5510 indirimi %${sgk.discount_5510} düşülmüş)` : ""}</span>
      <span><b>Damga</b> %{params.stamp_rate}</span>
      <span title={(params.brackets || []).map((b) => `${b.upto ? `≤ ${fmtTL(b.upto)}` : "üstü"} → %${b.rate}`).join("\n")}><b>GV dilimleri</b> {(params.brackets || []).map((b) => `%${b.rate}`).join(" / ")} ({params.year})</span>
      <span className="text-slate-500">Gün: puantaj çalışılan gün (30 tam ay) · AÜ istisnası kartta "Evet" olanlara</span>
      <Link to="/tanimlar/sabit-tanimlar?bolum=vergi" className="ml-auto inline-flex items-center gap-1 text-slate-700 hover:text-slate-900 hover:underline" data-testid={`${testid}-link`}><Settings2 className="w-3 h-3" /> Dilimleri düzenle</Link>
    </div>
  );
}
